import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { OtpInput } from "reactjs-otp-input";

import { ConfirmationResult } from "firebase/auth";
import firebase from "../firebaseConfig";
import { get_userLoginData } from "../services/api";
// To extend window with recaptchaVerifier
declare global {
  interface Window {
    recaptchaVerifier: any;
    confirmationResult: ConfirmationResult;
  }
}

const Login: React.FC = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const [sendFlag, setSendFlag] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [verificationId, setVerificationId] = useState("");
  const [isLogin, setIslogin] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError("");

    if (!mobileNumber.trim() || mobileNumber.length !== 10) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    setLoginLoading(true);

    const phoneNumber = `+91${mobileNumber}`;
    // const appVerifier = window.recaptchaVerifier;
    // const formatedPhone=mobileNumber.startsWith('+')? mobileNumber:`+91${mobileNumber}`
    const recaptchaVerification = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
      }
    );
    firebase
      .auth()
      .signInWithPhoneNumber(phoneNumber, recaptchaVerification)
      .then((confirmationResult) => {
        setVerificationId(confirmationResult.verificationId);
        console.log("OTP send successfully");
        setLoginLoading(false);
        setSendFlag(true);
      })
      .catch((err) => {
        console.error("Error sending OTP", err);
        setLoginLoading(false);
      });
  };

  const handleVerify = async (e: any) => {
    e.preventDefault();
    setError("");

    if (!otp || otp.length !== 6) {
      setError("Enter valid 6-digit OTP");
      return;
    }

    setVerifyLoading(true);
    try {
      console.log("Login Detail", mobileNumber);
      const credential = firebase.auth.PhoneAuthProvider.credential(
        verificationId,
        otp
      );
      firebase
        .auth()
        .signInWithCredential(credential)
        .then(() => {
          console.log("phone number verified.login successfully");

          getLoginUser();
          setVerifyLoading(false);
        })
        .catch((err) => {
          console.error("Error in verify OTP", err);
          setVerifyLoading(false);
          setError("Invalid OTP, Please enter valid OTP");
        });
    } catch (err) {
      console.log("error during login", err);
      setVerifyLoading(false);
    }
  };

  const getLoginUser = async () => {
    try {
      const body = {
        numbers: mobileNumber,
        latitude: "-",
        longitude: "-",
        notification_id: "-",
      };

      console.log("Body of login", body);

      await get_userLoginData(body).then(
        async (res) => {
          console.log("User data received:", res.data);

          if (res.data.alreadyExist === "no" && res.data.newUser === "yes") {
            alert("User not found");

            setSendFlag(false);
            setOtp("");
            setMobileNumber("");
          } else {
            localStorage.setItem("profile", JSON.stringify(res.data));
            setIslogin(true);
            localStorage.setItem("isLogin", "true");
            // alert("Login successfully");
            navigate("/profile");
            window.location.reload();
          }
        },
        (err) => {
          console.log("Get user error", err);
        }
      );
    } catch (error) {
      console.log("OTP Verification Error:", error);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="w-full justify-center">
        {sendFlag ? (
          <>
            <p className="text-center text-2xl mt-8">Enter verification code</p>
            <p className="text-gray-500 text-center text-xl mt-2">
              We sent an SMS to your mobile number
            </p>

            <form
              onSubmit={handleVerify}
              className="mt-6 flex flex-col items-center"
            >
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                separator={<span style={{ marginLeft: 10 }}></span>}
                inputStyle={{
                  width: "50px",
                  marginBottom: "10px",
                  height: "50px",
                  borderColor: "red",
                  borderWidth: "1px",
                  borderRadius: "10px",
                }}
              />

              <button
                type="submit"
                disabled={verifyLoading}
                className={`flex items-center justify-center gap-2 w-[80%] md:w-[35%] mt-9 lg:w-[25%] mb-9 text-white py-3 rounded-lg transition-all ${
                  verifyLoading
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-gradient-to-r from-black to-red-700 hover:opacity-90"
                }`}
              >
                {verifyLoading && (
                  <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {verifyLoading ? "Verifying..." : "VERIFY"}
              </button>

              {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
            </form>
          </>
        ) : (
          <>
            <p className="text-2xl font-bold text-center mt-8">Login</p>
            <p className="text-sm text-center mt-2">Create your account</p>

            <form
              onSubmit={handleSubmit}
              className="mt-6 flex flex-col items-center"
            >
              <input
                type="tel"
                placeholder="Enter mobile number"
                value={mobileNumber}
                maxLength={10}
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  setError("");
                }}
                className="p-3 border w-[80%] md:w-[50%] mb-4 lg:w-[30%] border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              />

              {error && (
                <p className="text-red-500 text-sm mt-1 mb-1">{error}</p>
              )}
              <div id="recaptcha-container"></div>
              <button
                type="submit"
                disabled={loginLoading}
                className={`flex items-center justify-center gap-2 w-[80%] md:w-[50%] mt-9 lg:w-[30%] mb-9 text-white py-3 rounded-lg transition-all ${
                  loginLoading
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-gradient-to-r from-black to-red-700 hover:opacity-90"
                }`}
              >
                {loginLoading && (
                  <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {loginLoading ? "Sending OTP..." : "SEND OTP"}
              </button>
            </form>
          </>
        )}
      </div>
    </>
  );
};

export default Login;
